import { lazy, Suspense } from "react";

import { PageContainerSkeleton } from "components/organisms/PageContainer/skeleton";
import { Paths } from "configs";
import { RouteProps } from "react-router-dom";

const DashboardPage = lazy(() => import("pages/Dashboard"));
const CSATPage = lazy(() => import("pages/Report/CSAT"));
const CSATByObjectPage = lazy(() => import("pages/Report/CSATByObject"));
const CSATCorpPage = lazy(() => import("pages/Report/CSATCorp"));
const ResultsPage = lazy(() => import("pages/Results"));
const ResultDetalPage = lazy(() => import("pages/Results/Detail"));
const SchemasPage = lazy(() => import("pages/Schemas"));
const SchemaDetailPage = lazy(() => import("pages/Schemas/Detail/detail"));
const SchemaCreatePage = lazy(() => import("pages/Schemas/Detail/create"));
const SchemaDashboardPage = lazy(() => import("pages/Schemas/Dashboard"));
const SchemaResultsPage = lazy(() => import("pages/Schemas/Results"));
const SchedulesPage = lazy(() => import("pages/Schedules"));
const ScheduleDetailPage = lazy(() => import("pages/Schedules/Detail/detail"));
const ScheduleCreatePage = lazy(() => import("pages/Schedules/Detail/create"));
const ScheduleDashboardPage = lazy(() => import("pages/Schedules/Dashboard"));
const ScheduleResultsPage = lazy(() => import("pages/Schedules/Results"));
const SurveyLinksPage = lazy(() => import("pages/SurveyLinks"));

export const DashboardSuspenseWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Suspense fallback={<PageContainerSkeleton withBreadcrumbs />}>
    {children}
  </Suspense>
);

export const DashboardRoutes: Array<
  RouteProps & {
    useSuspense?: boolean;
    checkPermission?: boolean;
  }
> = [
  // #region Dashboard
  {
    path: Paths.General.App,
    index: true,
    element: <DashboardPage />,
    useSuspense: true,
  },
  // #endregion
  // #region Schema Management
  {
    path: Paths.SchemaManagement.Schemas,
    index: true,
    element: <SchemasPage />,
    useSuspense: true,
  },
  {
    path: Paths.SchemaManagement.SchemaCreate,
    index: true,
    element: <SchemaCreatePage />,
    useSuspense: true,
  },
  {
    path: `${Paths.SchemaManagement.SchemaDetail}/:id`,
    index: true,
    element: <SchemaDetailPage />,
    useSuspense: true,
  },
  {
    path: Paths.SchemaManagement.SchemaDashboard,
    index: true,
    element: <SchemaDashboardPage />,
    useSuspense: true,
  },
  {
    path: Paths.SchemaManagement.SchemaResults,
    index: true,
    element: <SchemaResultsPage />,
    useSuspense: true,
  },
  // #endregion
  // #region Schedule Management
  {
    path: Paths.ScheduleManagement.Schedules,
    index: true,
    element: <SchedulesPage />,
    useSuspense: true,
  },
  {
    path: Paths.ScheduleManagement.ScheduleCreate,
    index: true,
    element: <ScheduleCreatePage />,
    useSuspense: true,
  },
  {
    path: `${Paths.ScheduleManagement.ScheduleDetail}/:id`,
    index: true,
    element: <ScheduleDetailPage />,
    useSuspense: true,
  },
  {
    path: `${Paths.ScheduleManagement.ScheduleDashboard}/:scheduleId`,
    index: true,
    element: <SchemaDashboardPage />,
    useSuspense: true,
  },
  {
    path: Paths.ScheduleManagement.ScheduleDashboard,
    index: true,
    element: <ScheduleDashboardPage />,
    useSuspense: true,
  },
  {
    path: Paths.ScheduleManagement.ScheduleResults,
    index: true,
    element: <ScheduleResultsPage />,
    useSuspense: true,
  },
  {
    path: `${Paths.ScheduleManagement.ScheduleResults}/:scheduleId`,
    index: true,
    element: <SchemaResultsPage />,
    useSuspense: true,
  },
  {
    path: Paths.ScheduleManagement.Results,
    index: true,
    element: <ResultsPage />,
    useSuspense: true,
  },
  {
    path: `${Paths.ScheduleManagement.ResultDetail}/:schemaId/:id`,
    index: true,
    element: <ResultDetalPage />,
    useSuspense: true,
  },
  {
    path: Paths.ScheduleManagement.SurveyLinks,
    index: true,
    element: <SurveyLinksPage />,
    useSuspense: true,
  },
  // #endregion
  // #region Report
  {
    path: Paths.Report.CSAT,
    index: true,
    element: <CSATPage />,
    useSuspense: true,
  },
  {
    path: Paths.Report.CSATByObject,
    index: true,
    element: <CSATByObjectPage />,
    useSuspense: true,
  },
  {
    path: Paths.Report.CSATCorp,
    index: true,
    element: <CSATCorpPage />,
    useSuspense: true,
  },
  // #endregion
];
